import { Base } from '../base-component';

import './our-campaigns-item.component.scss';
import SliderComponent from '../slider/slider.component';
import { MediaQueryService } from '../../services/media-query.service';

export class OurCampaignsItem extends Base {

	constructor(element){
		super(element)
	}

	init(){};

	bindEvents(){};

}



// WEBPACK FOOTER //
// ./components/our-campaigns-item/our-campaigns-item.component.ts